import { combineReducers } from 'redux';

import sadt, { SadtFormState } from './sadt';
import lot, { TISSLotState } from './lot';
import expense, { ExpenseState } from './expense';

export type TissState = {
  sadt: SadtFormState;
  lot: TISSLotState;
  expense: ExpenseState;
};

const tissReducer = combineReducers<TissState>({
  sadt,
  lot,
  expense,
});

export default tissReducer;
